import { chains } from '@particle-network/chains';
const accountContracts = chains
    .getAllChainInfos()
    .filter((chain) => chain.features?.length && chain.features.some((feature) => feature.name === 'ERC4337'))
    .reduce((previous, current) => {
    const erc4337Feature = current.features.find((feature) => feature.name === 'ERC4337');
    erc4337Feature.contracts?.forEach((contract) => {
        if (previous[contract.name]) {
            const configs = previous[contract.name].find((item) => item.version === contract.version);
            if (configs) {
                configs.chainIds.push(current.id);
            }
            else {
                previous[contract.name].push({
                    version: contract.version,
                    chainIds: [current.id],
                });
            }
        }
        else {
            previous[contract.name] = [
                {
                    version: contract.version,
                    chainIds: [current.id],
                },
            ];
        }
    });
    return previous;
}, {});
export const aaOptions = {
    accountContracts,
};
//# sourceMappingURL=aaOptions.js.map